const getters = {
    sidebar: state => state.app.sidebar,
    visitedViews: state => state.app.visitedViews,
    loginStatus: state => state.user.loginStatus,
    userName: state => state.user.userName,
    useInfo: state => state.user.useInfo,
    groupType: state => state.user.groupType,
    roles: state => state.user.roles,
    permissions: state => state.user.permissions,
    permission_routers: state => state.permission.routers,
    default_openeds: state => state.permission.defaultOpeneds,
    addRouters: state => state.permission.addRouters,
    btnCode: state => state.user.btnCode ? state.user.btnCode : JSON.parse(localStorage.getItem("btnCode")),
};
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js